<template>
  <v-container class="pa-6">
    <!-- API FAQ -->
    <h1>API FAQ</h1>
    <p>BeCool provides API REST based services for clients to programmatically interact with their delivery service.
      BeCool has implemented Swagger to document the API specifications and provide a platform for functional testing.
      The link to Swagger can be found below:
    </p>
    <v-btn color="primary" dark class="mb-4"  target="_blank" @click="toSwagger">
      Swagger
    </v-btn>

    <p>Access to the API is controlled via the use of API keys. Keys must be provided with every request to the API in one of the following ways:
    </p>
    <ul>
      <li>As an HTTP header: X-Api-Key</li>
      <li>As a query parameter: key</li>
      <li>As a cookie: Api-Key</li>
    </ul>
    <p>You may generate and maintain the keys via the portal which can be used for authenticating with the API.
      These keys grant full access and do not expire so are best suited for server based workloads where the key is not shared with user devices.
    </p>

    <v-img
      :src="require('../../assets/api_key.png')"
      alt="API Example"
      max-width="500"
      class="my-4"
    ></v-img>

    <h2>API Rate limits</h2>
    <p>
      Rate limits are enforced by the API. If a rate limit is reached the API will return the HTTP response 429 Too Many Requests.
      Note that requests denied by the rate limiter are included in rate limit calculations so requests will need to be throttled.
      Should you find the rate limits to be insufficient for regular use please contact BeCool.

      <br><br>
      <strong>Current rate limits (as at 2025-12-04)</strong>
      <br><br>

      <strong>Production</strong>
      <br>
      150 calls per 5 seconds<br>
      6,000 calls per hour<br>
      70,000 calls per day


      <br><br>

      <strong>Staging\Development</strong>
      <br>
      100 calls per 5 seconds<br>
      4,000 calls per hour<br>
      20,000 calls per day
    </p>

    <h2>Common coding scenarios - Pseudocode</h2>
    <ul>
      <li><p>What time windows are available for the suburb</p>
        <p>Input example</p>
        <v-img
          :src="require('../../assets/optionadv.png')"
          alt="API Example"
          max-width="500"
          class="my-4"
        ></v-img>
      </li>
      <li>How to determine what the closest consolidation depot is for a delivery</li>
    </ul>

    <h2>Most common rejection reason</h2>
    <p>When creating a delivery, the most common reason for a failed delivery submission occurs due to one of these three main reasons:</p>
    <ul>
      <li>There is not enough time between delivery creation and delivery to meet the available line hauls to get to the destination depot.</li>
      <li>The cutoff for delivery creation has passed.</li>
      <li>We do not deliver to that suburb and or postcode.</li>
    </ul>
    <p>
      There is an API clients can use to check all three of these in a single call. Please see the swagger documentation for more details.
    </p>
    <v-img
      :src="require('../../assets/createdeadline.png')"
      alt="API Example"
      max-width="500"
      class="my-4"
    ></v-img>

    <h2>Webhooks</h2>
    <p>Webhooks can be registered via the API or portal. When an event is triggered the BCRC API will POST details of the event to the webhook URL if it is enabled.
      All webhook URLs must use HTTPS and you may only register one webhook per event type. When a webhook is registered,
      a secret key is generated and returned by the API which may be used to validate webhook messages. Due to the way BCRC API implements webhooks,
      we cannot guarantee that event messages will be sent in order or only once, your application must be able to handle out of order or duplicated messages.</p>
    <p>It is important to process webhook calls quickly.
      The BCRC API does not process any data returned to a webhook call and so we recommend that your application simply returns a 204 No Content response.
      Any response with a status 2xx status code will be considered successful.
      If your application does not respond with a 2xx status code or within 10 seconds the call is considered to have failed and the API will try again
      after a few minutes and will continue to retry for up to 45 minutes.</p>
    <h3 class="note">Note:
      <small>
        Where the event relies on communication from the driver’s phone we do not guarantee the timelines of these webhook calls.
        Our driver phones are designed to work offline so messages might come in hours later than the actual event.
      </small>
    </h3>
    <p>Where the event relies on communication from the driver’s phone
      we do not guarantee the timelines of these webhook calls.
      Our driver phones are designed to work offline so messages might come in hours later than the actual event.</p>
    <p>To subscribe to The most commonly used webhook types are described below and use the same JSON syntax.</p>

    <v-img
      :src="require('../../assets/time_windows.png')"
      alt="API Example"
      max-width="500"
      class="my-4"
    ></v-img>

    <ul>
      <li>Delivery Created: Notifies every time a delivery is created, either via the API or by uploading a manifest to the portal. </li>
      <li>Delivery Deleted: Notifies every time a delivery is deleted.</li>
      <li>Delivery Exception: Notifies every time a delivery exception occurs.</li>
      <li>Delivery Scheduled: Notifies when a delivery has been scheduled for delivery.</li>
      <li>Delivery Rescheduled or Redirected: Notifies when a delivery has been rescheduled to a new delivery window or delivery address.</li>
      <li>Delivery Completed: Notifies when a delivery has been completed.</li>
      <li>Out For Delivery: Notifies when a box has been loaded onto a vehicle for delivery.</li>
    </ul>

    <h2>Did you know</h2>
    <ul>
      <li>
        Our SMS system does basic validation on the phone number before attempting to send an SMS.
        If it fails validation it will not send the SMS. Before enquiring about SMS delivery please check the customer's phone number in the portal.
      </li>

    </ul>

  </v-container>
</template>


<script >
export default {
  name: 'FAQ',
  data() {
    return {
      Items: null,
    }
  },
  methods: {
    toSwagger() {
      window.open(process.env.API_URL + '/docs/swagger?key='+ encodeURI(this.$store.state.auth.key), '_blank');
    }
  }
}
</script>

<style scoped>

h1 {
  font-weight: bold;
  margin-bottom: 16px;
}
h2 {
  margin-top: 24px;
  font-weight: 600;
}
h3 {
  margin-top: 20px;
  font-weight: 500;
}
ul {
  margin-left: 20px;
}

h3.note {
  color: red;
  font-weight: bold;
}

.note small {
  color: black;
}

</style>



// WEBPACK FOOTER //
// src/components/util/FAQ.vue